//OrderFlowProductWorldList.jsx
import React, { useCallback, useEffect, useState, useRef } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import useFetch from '../../hooks/useFetch';
import Tooltip from '../../components/utils/Tooltip';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCertificate, faCheck, faClipboardCheck, faDiamond, faSpinner, faFileAlt, faBoxesPacking, faGift, faRecycle } from '@fortawesome/free-solid-svg-icons';
import './OrderFlowProducts.css'; 
import OrderFlowEarningCalculator from './OrderFlowEarningCalculator';
// import './OrderFlowEarningCalculator.css'; 

const ProductWorldListComponent = ({ param1, param2, sellerRoute }) => {
    const authState = useSelector(state => state.authReducer);
    const [userId, setUserId] = useState(authState.user._id);
    const [fetchData, { loading }] = useFetch();
    const navigate = useNavigate();
    const moduleName = param1;
    const currency = param2;
    // const location = useLocation();
    // const sellerRoute = location.pathname.replace("/orderflow-products/", "");
    const [productMasters, setProductMasters] = useState([]);
    const [myProducts, setMyProducts] = useState([]);
    const [productFeatureClicked, setProductFeatureClicked] = useState(false);
    const [showFeatures, setShowFeatures] = useState(false);
    const [featureStates, setFeatureStates] = useState({});
    const [productMasterRecords, setProductMasterRecords] = useState({});

    const fetchProductMasters = useCallback(() => {
        const config = {
            url: "/productmaster",
            method: "get",
            params: {
                sellerRoute: sellerRoute,   
            },
            headers: {
                Authorization: authState.token,
                "Content-Type": "application/json",
            },
        };

        fetchData(config, { showSuccessToast: false })
            .then(response => {
                // console.log("Response fetchProductMasters :", response.productmasters);
                if (response && Array.isArray(response.productmasters)) {
                    setProductMasters(response.productmasters);
                    setProductMasterRecords(response.productmasters.length);
                } else {
                    console.error("Invalid response format: Products not found in response");
                }
            })
            .catch(error => {
                console.error("Error fetching ProductMasters:", error);
            });
    }, [authState.token, fetchData]);

    useEffect(() => {
        if (!authState.isLoggedIn) return;
        fetchProductMasters();
    }, [authState.isLoggedIn, fetchProductMasters]);

    const fetchMyProducts = useCallback(() => {
        const config = {
            url: "/myproducts/list",
            method: "post",
            headers: { Authorization: authState.token },
            data: {userId: userId}
        };

        fetchData(config, { showSuccessToast: false })
            .then(response => {
                if (response && Array.isArray(response.myproducts)) {
                    setMyProducts(response.myproducts);
                    // console.log("My products from server (response.myproducts).....", response.myproducts);
                } else {
                    console.error("Invalid response format: Products not found in response");
                }
            })
            .catch(error => {
                console.error("Error fetching My Products:", error);
            });
    }, [authState.token, fetchData]);


    useEffect(() => {
        if (!authState.isLoggedIn) return;
        fetchMyProducts();
    }, [authState.isLoggedIn, fetchMyProducts]);

    const handleProductDetailsClick = (productId, product, isGeneral, hasPurchased) => {
        navigate('/buying-productdetails', {
            state:
            {
                productId: productId,
                productData: product,
                hasPurchased: hasPurchased,
                isGeneral: isGeneral
            }
        });
    };

    const toggleFeature = (productId) => {
        setFeatureStates((prevState) => ({
            ...prevState,
            [productId]: !prevState[productId]
        }));
    };

    const toProperCase = (str) => {
        if (str.toLowerCase() === 'cdr') {
            return 'Cultural.Devotional.Religious';
        }
        if (str.toLowerCase() === 'madsmania') {
            return 'MADSmania';
        }
        return str.replace(/\w\S*/g, (txt) => {
            return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
        });
    };

    // const sortedProductMasters = [...productMasters].sort((a, b) => a.displayIndex - b.displayIndex);

    const sortedProductMasters = [...productMasters].sort((a, b) => {
        if (a.displayIndex !== b.displayIndex) {
          return a.displayIndex - b.displayIndex;
        }
        return a.productName.localeCompare(b.productName);
      });


    const [selectedProduct, setSelectedProduct] = useState(null);
    const [showReferralEarningEstimation, setShowReferralEarningEstimation] = useState(false);

    const handleShowReferralIncomeEstimatorClicked = (product) => {
        if (selectedProduct === product) {
            setShowReferralEarningEstimation(!showReferralEarningEstimation);
        } else {
            setSelectedProduct(product);
            setShowReferralEarningEstimation(true);
        }
    };

    const [showMicroPage, setShowMicroPage] = useState(false);
    const handleShowMicroPageClicked = (product) => {
        setShowMicroPage(true)
    };

    // Call method
    const handleCallClick = (contactNumber) => {
        window.location.href = `tel:${contactNumber}`;
    };

    // WhatsApp method
    const handleWhatsAppClick = (contactNumber) => {
        const whatsappUrl = `https://wa.me/${contactNumber}`;
        window.open(whatsappUrl, '_blank');
    };

    // Email method
    const handleEmailClick = (contactEmail) => {
        window.location.href = `mailto:${contactEmail}`;
    };
    

    return (
        <div className="product-list p-4 bg-gray-600 text-white min-h-screen mt-2">
            {moduleName}{currency}{sellerRoute}
            {loading ? (
                <div className="spinner-container flex justify-center items-center min-h-screen">
                    <div className="spinner text-white text-xl">
                        <FontAwesomeIcon icon={faSpinner} spin />
                    </div>
                </div>
            ) : (
                <div className="page-content">
                    <div className="flex flex-col items-center justify-center text-center">
                        {productMasterRecords < 1 && (
                            <div className="text-yellow-500 text-lg mt-4">
                                <p>Currently No Products Available!!</p>
                            </div>
                        )}
                    </div>
    
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mt-2">
                        {sortedProductMasters.map((product) => (
                            <div key={product.productCode} className="product-item bg-gray-800 p-6 rounded-lg shadow-lg flex flex-col justify-between">
                                <div className="mb-1 flex items-center">
                                    <img 
                                        src={
                                            `/api/downloads/orderflow/products/${product.productCode}.png` 
                                        }
                                        alt={"No Image " + product.productName} 
                                        className="rounded-md flex justify-items-center"
                                    />
                                </div>
                                <div className="details-container mt-2 mb-2">
                                    <p className={`${product.isReseller ? 'text-yellow-400' : 'text-blue-300'}`}>
                                        {product.productName}
                                    </p>
                                    <p className="text-sm text-white mb-2">Brand Name: {product.brandName}</p>
                                    <p className="text-sm text-white mb-2">Seller Name: {product.sellerName}</p>
                                    { product.isBOGO && ( 
                                        <p className="text-lg text-white">Buy One Get One Offer</p>
                                    )}
                                    <p className="text-m text-gray-600">
                                        <del className='text-red-500'>MRP: {product.currency}{product.listPrice}</del>
                                    </p>
                                    <p className="text-m text-white">
                                        {product.isGeneral === false && (
                                            <span>Referral </span>
                                        )}
                                        {product.isReseller && (
                                            <>
                                            <span className="text-yellow-400">
                                                Available through Reseller<br/>
                                            </span>
                                            <span>Max </span>
                                            </>
                                        )}
                                        Price: {product.currency}{product.offerPrice.toFixed(2)}
                                    </p>
                                    { product.deliveryCharges !== 0 && ( 
                                        <p className="text-m text-white">
                                            Delivery Charges: {product.currency}{product.deliveryCharges.toFixed(2)}
                                        </p>
                                    )}
                                    { product.isSubscription && ( 
                                        <>
                                            <p className="text-m text-green-300">This is Subscription</p>
                                            <p className="text-sm text-blue-800">Validity Days: {product.subsValidityDays}</p>
                                        </>
                                    )}
                                    { product.isT5WPageTopup && ( 
                                        <>
                                            <p className="text-m text-green-300">This is for Think5Whys Page Read Topup</p>
                                            <p className="text-sm text-blue-800">Reads: {product.pageTopupCount}</p>
                                        </>
                                    )}
                                    { product.isCombo && ( 
                                         <>
                                            <p className="text-m text-green-300">This is a Combo/Kit</p>
                                            <p className="text-sm text-black">{product.comboName}</p>
                                            <p className="text-sm text-purple-800">{product.comboDetails}</p>
                                        </>
                                    )}
                                    { product.isCustomPacking && ( 
                                         <>
                                            <p className="text-m text-white">
                                                <FontAwesomeIcon className="mr-4" icon={faBoxesPacking} />
                                                You can customise packing for this product!!
                                            </p>
                                        </>
                                    )}
                                    { product.isGiftPacking && ( 
                                         <>
                                            <p className="text-m text-red-500">
                                                <FontAwesomeIcon className="mr-4" icon={faGift} />
                                                You can request gift packing for this product!!
                                            </p>
                                        </>
                                    )}
                                    { product.isPackagingReturn && ( 
                                         <>
                                            <p className="text-m text-green-300">
                                                <FontAwesomeIcon className="mr-4" icon={faRecycle} />
                                                You can opt for packaging material return after the use for this product!!
                                            </p>
                                        </>
                                    )}
                                    { product.isMicroPage && ( 
                                         <>
                                            <button
                                                className="mt-2 text-m bg-green-500 text-white hover:text-green-400"
                                                onClick={() => handleShowMicroPageClicked(product)}
                                            >
                                                Show Pretty Page
                                            </button>
                                            { showMicroPage(
                                                <p>Coming Soon</p>
                                            )}
                                        </>
                                    )}
                                </div>
                                {product.isGeneral === false && (
                                    <div className='details-container'>
                                        <button
                                            className="mt-2 text-m bg-green-500 text-white hover:text-green-400"
                                            onClick={() => handleShowReferralIncomeEstimatorClicked(product)}
                                        >
                                            {selectedProduct === product && showReferralEarningEstimation
                                                ? 'Hide Referral Earnings Estimation'
                                                : 'View Referral Earnings Estimation'}
                                        </button>
                                    </div>
                                )}
                                {/* {product.isGeneral === true && (
                                    <div className='flex flex-col details-container'>
                                        <button
                                            className="mt-2 text-m bg-green-500 text-white hover:text-green-400"
                                            onClick={() => handleShowReferralIncomeEstimatorClicked(product)}
                                        >
                                            Confirm Order
                                        </button>
                                    </div>
                                )} */}
                                {selectedProduct === product && showReferralEarningEstimation && (
                                    <div className="overlay mt-4 p-4 bg-gray-700 rounded-lg shadow-lg">
                                        <div className="order-flow-earning-calculator-container w-full">
                                            <OrderFlowEarningCalculator param1={product.offerPrice} param2={product.mlmPlan} />
                                            <button
                                                className="mt-2 bg-red-600 hover:bg-red-800 text-white font-bold py-2 px-4 rounded"
                                                onClick={() => setShowReferralEarningEstimation(false)}
                                            >
                                                Close
                                            </button>
                                        </div>
                                    </div>
                                )}
                                <div className="details-container mt-2">
                                    <h2 className="text-purple-500 text-lg mb-2">Buy for Yourself or Gifting</h2>
                                </div>
                                <div className="details-container">
                                    <button
                                        onClick={() => handleProductDetailsClick(product._id, product, product.isGeneral, false)}
                                        className="bg-green-500 hover:bg-green-700 text-white font-bold py-2 px-4 rounded"
                                    >
                                        Details & Buy
                                    </button>
                                </div>
                                {featureStates[product._id] && (
                                    <div className="feature-container text-white bg-gray-700 p-4 rounded-md" dangerouslySetInnerHTML={{ __html: product.productFeatures }} />
                                )}
    
                                <div className="details-container mt-4">
                                    <h2 className={`${product.isAvailable ? 'text-green-400' : 'text-yellow-400'} text-lg font-semibold`}>
                                        {product.isAvailable ? "Available in the Store" : "Currently Unavailable"}
                                    </h2>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
    
};

export default ProductWorldListComponent;
